export default "__VITE_ASSET__NDm$ILcc__"